

export class StringValues {
  static replaceIfEmpty(source: string, replacement: string): string {
    return source?.length ? source : replacement;
  }
}